import { MealIdeas } from "../Components/Icons";

const obj = {
  title: "Meal Ideas",
  desc: "Quickly generate 5 custom meal ideas specific to your requirements.",
  category: "Meal Planning",
  Icon: MealIdeas,
  // tags: [],
  permissions: ["user"],

  fromColor: "gray-500",
  toColor: "gray-500",

  to: "/ai/ideas",
  api: "/ai/ideas",

  output: {
    title: "Meal Suggestions",
    desc: "Please be patient while we generate your meal suggestions. Depending on usage it could take up to 1 minute",
    // Icon: RefreshIcon,
    // color: "",
},

  video:
    "https://mealpalaivideos.s3.ap-southeast-2.amazonaws.com/Meal_Requirements.mp4",

     prompts: [{

        title:"Meal Requirements",
        desc: "Fill out the key information below to generate your meal suggestions",
        // n: 1,
        prompts: [
            { 
                title: "Meal Type", 
                attr: "mealtype",  
                value: "", 
                placeholder: "Dinner", 
                label: "Examples: breakfast, lunch, dinner, snack",
                // type: "textarea",
                maxLength: 20,
                // max: 100,
                // min: 5,
                required: true,
                error: "",
                example: "Lunch",
            },
            { 
                title: "Dietary requirements", 
                attr: "dietary",  
                value: "", 
                placeholder: "e.g vegan, anaphylactic to nuts, ketogenic diet", 
                label: "",
                type: "textarea",
                maxLength: 100,
                // max: 100,
                // min: 1,
                required: false,
                error: "",
                example: "Ketogenic diet and also gluten free. Trying to lose weight"
            },
            { 
                title: "Food preferences", 
                attr: "preferences",  
                value: "", 
                placeholder: "e.g no pork, lots of vegetables", 
                label: "",
                type: "textarea",
                maxLength: 100,
                // max: 100,
                // min: 1,
                required: false,
                error: "",
                example: "I love beef but also want some vegetarian suggestions with lots of vegetables"
            },
        ],
        example: {
output: `1. Grilled Steak with Roasted Vegetables: Grilled sirloin steak served with roasted brussels sprouts, carrots, and onions.
2. Baked Salmon with Cauliflower Rice: Baked salmon fillet served over a bed of cauliflower rice and steamed broccoli.
3. Zucchini Noodles with Creamy Tomato Sauce: Zucchini noodles tossed in a creamy tomato and basil sauce, topped with grilled chicken breast.
4. Greek Salad with Grilled Beef Strips: A classic Greek salad with lettuce, cucumber, tomato, feta cheese, and grilled beef strips.
5. Egg Salad: Hard-boiled eggs mashed with mayonnaise and served with a side of wilted spinach.
6. Cauliflower Crust Pizza: A cauliflower crust pizza topped with tomato sauce, mozzarella cheese, and vegetables of your choice.
7. Grilled Pork Chops with Asparagus: Grilled pork chops served with roasted asparagus and cherry tomatoes.
8. Shrimp and Broccoli Stir-Fry: Stir-fried shrimp and broccoli in a sauce made from coconut aminos, sesame oil, and ginger.
9. Beef and Vegetable Stir-Fry: Thinly sliced beef stir-fried with bell peppers, onions, and mushrooms.
10. Avocado and Egg Breakfast Bowl: Halved avocado filled with scrambled eggs and topped with salsa and bacon.
`,
            // outputs: [],
            // Icon: RefreshIcon,
            // color: "",
        }
    }]
        
}

export default obj